export type ImpersonationSession = {
  impersonatedUserEmail: string | null;
  impersonatedUserName: string | null;
  returnToControlCenterUrl: string | null;
  churchId: string | null;
  isOverallAdmin: boolean;
  isImpersonating: boolean;
};

export enum ImpersonationWarningCode {
  MissingEmail = 'missing-email',
  InvalidEmail = 'invalid-email',
  InvalidReturnUrl = 'invalid-return-url',
}

export type ApplyImpersonationResult = {
  warningCode: ImpersonationWarningCode | null;
};
